import { NgIf } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-image-preview',
  standalone: true,
  imports: [NgIf],
  templateUrl: './image-preview.component.html',
  styleUrl: './image-preview.component.css'
})
export class ImagePreviewComponent {

  @Input() imageUrl: string | null = null;
  @Output() close = new EventEmitter<void>();

  // Close if clicking outside the image container
  @HostListener('click', ['$event'])
  onBackgroundClick(event: MouseEvent) {
    // Close only if click target is background overlay, not the image or close icon
    if ((event.target as HTMLElement).classList.contains('overlay')) {
      this.close.emit();
    }
  }

  onCloseClick() {
    this.close.emit();
  }

}
